import { ColumnActionsMode, IDetailsColumnStyles } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import { rightAlignHeaderStyle } from 'common/utils/columnUtilities';

const commonColumnProps: Partial<ColumnData> = {
  isResizable: true,
  isPadded: false,
  isCollapsible: false,
  toggleVisibility: true,
  isVisible: true,
  columnActionsMode: ColumnActionsMode.disabled,
};

export const columns: ColumnData[] = [
  {
    key: 'transactionType',
    name: 'Type',
    fieldName: 'transactionType',
    minWidth: 60,
    maxWidth: 60,
    ...commonColumnProps,
  },
  {
    key: 'name',
    name: 'Name',
    fieldName: 'name',
    minWidth: 150,
    maxWidth: 180,
    ...commonColumnProps,
  },
  {
    key: 'description',
    name: 'Description',
    fieldName: 'description',
    minWidth: 150,
    maxWidth: 200,
    ...commonColumnProps,
  },
  {
    key: 'transactionNo',
    name: 'Transaction No.',
    fieldName: 'transactionNo',
    minWidth: 100,
    maxWidth: 120,
    ...commonColumnProps,
  },
  {
    key: 'invoiceDate',
    name: 'Date',
    fieldName: 'invoiceDate',
    minWidth: 80,
    maxWidth: 100,
    ...commonColumnProps,
  },
  {
    key: 'appliedAmount',
    name: 'Amount',
    fieldName: 'appliedAmount',
    minWidth: 80,
    maxWidth: 100,
    styles: rightAlignHeaderStyle,
    ...commonColumnProps,
  },
  {
    key: '_isAccountingEntryStampedComplete',
    name: '',
    fieldName: '_isAccountingEntryStampedComplete',
    minWidth: 40,
    maxWidth: 60,
    ...commonColumnProps,
  },
  {
    key: 'action',
    name: '',
    fieldName: 'action',
    minWidth: 40,
    maxWidth: 60,
    ...commonColumnProps,
  },
];
